import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-default-filter-page-template',
  templateUrl: './default-filter-page-template.component.html',
  styleUrls: ['./default-filter-page-template.component.scss'],
})
export class DefaultFilterPageTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
